// extracted by mini-css-extract-plugin
module.exports = {"margin":"TopPicks_margin__CCoab","headerBox":"TopPicks_headerBox__dz0YN","seeAll":"TopPicks_seeAll__xzrct","header":"TopPicks_header__89iqa","Link":"TopPicks_Link__D3UWh"};